<template>
  <DataListStateful
    title="Регионы"
    resource="regions"
    store="regions"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        {
          title: "Страна",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
        {
          title: "Сокращение",
          name: "code",
          dataPath: "Code",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        country: {
          title: "Страна",
          type: "reference",
          resource: "countries",
        },
        code: {
          title: "Сокращение",
          type: "text",
        },
      },
    };
  },
};
</script>
